import {
  ButtonDesigns,
  ButtonTypes,
  getFontCss,
  styleConstants,
  themeConstants,
} from '@paywithextend/components'
import React from 'react'
import Button from 'src/components/Button/Button'
import Popup from 'src/components/Popup/Popup'
import { useFlyoutDispatch } from 'src/hooks'
import Trns from 'src/localization/Trns'
import { createSetIsDownloadSuccessPopupOpen } from 'src/redux/actions/app.actions'
import { css } from 'styled-components'

const DownloadSuccessPopup: React.FC = () => {
  const dispatch = useFlyoutDispatch()

  const close = (): void => {
    dispatch(createSetIsDownloadSuccessPopupOpen(false))
  }

  return (
    <Popup
      onClose={close}
      css={css`
        display: flex;
        flex-direction: column;
        align-items: flex-start;
      `}
    >
      <span
        css={css`
          ${getFontCss(
            32,
            themeConstants.colors.font_primary,
            styleConstants.fontFamilies.medium,
          )};
          margin-bottom: 40px;
        `}
      >
        <Trns source={'Success!'} />
      </span>
      <span
        css={css`
          ${getFontCss(
            16,
            themeConstants.colors.font_primary,
            styleConstants.fontFamilies.regular,
          )}
        `}
      >
        <Trns
          source={
            'Your download is being generated. You will receive an email notification when it is ready.'
          }
        />
      </span>
      <Button
        css={css`
          margin-top: 40px;
        `}
        type={ButtonTypes.button}
        design={ButtonDesigns.designCta}
        big
        text={<Trns source={'Got it, thanks!'} />}
        testId={'gotItBtn'}
        onClick={close}
      />
    </Popup>
  )
}

export default DownloadSuccessPopup
